import { queryClient } from "../client-query";
import { globalStore } from "../eventstore/global-store";
import { ofType } from "../eventstore/of-type.operator";
import { KYC_HISTORY } from "./resources";

export const verificationEffects = [
  // Respond to Auth change
  globalStore
    .pipe(ofType("AUTH_DONE"))
    .subscribe(() => queryClient.invalidateQueries([KYC_HISTORY])),
];
